import { COUNTRY_SELECT_OPTIONS } from '@ben/common/countries';
import MultiSelect from '@ben/orion/multi-select';
import { Controller, useFormContext } from 'react-hook-form';

const CountriesSelect = () => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name="countries"
      render={({ field }) => {
        const { value, onChange, ref, ...rest } = field;
        return (
          <MultiSelect
            {...rest}
            data={COUNTRY_SELECT_OPTIONS}
            label="Countries"
            value={value?.map((country: string | number) => country.toString())}
            onChange={onChange}
            searchable
          />
        );
      }}
    />
  );
};

export default CountriesSelect;
